import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  message,
  Input,
  Select,
  Checkbox,
} from "antd";
import { useEffect, useState } from "react";
import patchDataClaim from "../../../../services/patchDataClaim";
import {
  costCenters,
  leaders,
  subCostCenters,
} from "../../../../utils/details";
import { useQuery } from "@tanstack/react-query";
import { handleFetchFirms } from "../../../../api/firms";
import accessLevels from "../../../../utils/accessLevels";
const { Option } = Select;

export default function EditUser({
  isVisible,
  selected,
  setVisible,
  refetch,
}: any) {
  const [isLoading, setLoading] = useState(false);
  const [isActive, setActive] = useState(selected?.isActive);

  const [form] = Form.useForm();
  const params = `name=${""}`;

  const { data: firms } = useQuery({
    queryKey: ["firms", 1, 40, params],
    queryFn: () =>
      handleFetchFirms({
        page: 1,
        limit: 40,
        params,
      }),
  });

  const onSubmit = async () => {
    setLoading(true);
    const values = await form.getFieldsValue();
    const uri = `claim/claimers/${selected?._id}/update/details`;
    const data = {
      ...values,
      isActive,
    };
    const response = await patchDataClaim(data, uri);
    if (response.success === false) {
      message.error("Something went wrong");
    } else {
      if (response.success) {
        message.success("Updated Successfully");
        refetch();
        form.resetFields();
        hideModal();
      } else {
        message.error(response.message);
      }
    }
    setLoading(false);
  };

  const hideModal = () => {
    setVisible(false);
  };

  const formatMobile = (mobile: any) => {
    let num = mobile ? mobile : "";
    let trim = num?.trim();
    let mob = trim?.slice(-9);
    return mob;
  };

  const handleSelectedFirm = (value: any) => {
    const id = form.getFieldValue("firm");
    const firm = firms?.records?.filter((user: any) => user?._id === id);
    form.setFieldsValue({
      company: firm[0]?.name,
    });
  };

  const centerOptions = costCenters.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const subOptions = subCostCenters.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const leaderOptions = leaders.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const companyOptions = firms?.records?.map((firm: any, index: number) => (
    <Select.Option key={index} value={firm._id}>
      {firm.name}
    </Select.Option>
  ));




  const accessLevelOptions = accessLevels?.map((level: any, index: number) => (
    <Select.Option key={index} value={level.value}>
      Level: {level.value}
    </Select.Option>
  ));



  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      name: selected?.name,
      mobile: selected?.mobile,
      mobile2: selected?.mobile2,
      email: selected?.email,
      company: selected?.company,
      firm: selected?.firm?._id,
      costCenter: selected?.costCenter,
      subCostCenter: selected?.subCostCenter,
      leader: selected?.leader,
      businessHead1: selected?.businessHead1,
      businessHead2: selected?.businessHead2,
      kjlID: selected?.kjlID,
      accessLevel: selected?.accessLevel,
    });
    setActive(selected?.isActive);
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Update User"
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="updateClaimer"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateClaimer"
        form={form}
        layout="vertical"
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Full name"
              initialValue={selected?.name}
              rules={[
                {
                  required: false,
                  message: "Please enter name",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="Full name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="kjlID"
              label="KJL ID"
              initialValue={formatMobile(selected?.kjlID)}
              rules={[
                {
                  required: false,
                  message: "Please enter KJL ID",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="KJL ID" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="email"
              label="Email"
              initialValue={selected?.email}
              rules={[
                {
                  required: false,
                  message: "Please enter email",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="Email" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              label="User Mobile"
              initialValue={formatMobile(selected?.mobile)}
              rules={[
                {
                  required: false,
                  message: "Please enter mobile number 1",
                },
              ]}
            >
              <Input style={{ width: "100%" }} placeholder="Mobile number 1" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="firm"
              label="Current Legal entity"
              rules={[
                {
                  required: false,
                  message: "Please select legal entity",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select legal entity"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onSelect={() => handleSelectedFirm(form.getFieldValue("firm"))}
              >
                {companyOptions}
              </Select>
            </Form.Item>
            <div className="hidden">
              <Form.Item
                name="company"
                label="Current Legal entity"
                rules={[
                  {
                    required: false,
                    message: "Please select legal entity",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select legal entity"
                  optionFilterProp="children"
                  filterOption={(input: any, option: any) =>
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {companyOptions}
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="costCenter"
              label="Cost center"
              rules={[
                {
                  required: false,
                  message: "Please select cost center",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Cost Center"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {centerOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="subCostCenter"
              label="Sub cost center"
              rules={[
                {
                  required: false,
                  message: "Please Sub Cost Center",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Sub Cost Centery"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {subOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="businessHead1"
              label="Business segment head (1)"
              rules={[
                {
                  required: false,
                  message: "Please select Business Head 1",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Business Head 1"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {leaderOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="businessHead2"
              label="Business Segment head (2)"
              rules={[
                {
                  required: false,
                  message: "Please select Business Head 2",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Business Head 2"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {leaderOptions}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="accessLevel"
              label="Access Level"
              rules={[
                {
                  required: false,
                  message: "Please select Access Level",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Access Level"
                optionFilterProp="children"
                style={{ width: "100%" }}
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {accessLevelOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>

          <Col>
            <div className="mt-8 ">
              <Checkbox
                checked={isActive}
                onChange={() => setActive(!isActive)}
              >
                Active Account
              </Checkbox>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
